import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
// not supported anymore
// import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import  {ModalComponent} from '../../Shared/Components/modal/modal.component';
import {ContactModalComponent} from '../../Shared/Components/contact-modal/contact-modal.component';
import { ConfigLoaderService } from 'app/Shared/Services/Config/config-loader.service';
// import { ConfigLoaderService } from 'src/app/Shared/Services/Config/config-loader.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent implements OnInit {
  // modalRef!: MDBModalRef;
  private dialogRefModal !: MatDialogRef<ModalComponent>;
  private dialogRefContactModal !: MatDialogRef<ContactModalComponent>
  copyright!:string;
  mailText:string = "";


  constructor(
    // private modalService: MDBModalService,
    private dialog: MatDialog,
    private _configLoaderService: ConfigLoaderService,

   ) { }

  ngOnInit(): void {
    //this.copyright=ConfigLoaderService.settings.AppSettings.copyRight + "All Rights Reserved.For internal use only";
    this.copyright= (new Date()).getFullYear() + " " + ConfigLoaderService.settings.AppSettings.copyRight;
   console.log(this.copyright);
  }
  getElementDetails(elementId:string) {

    
    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: '',
      containerClass: '',
      animated: true,
      data: {
          selectedoffering:  elementId,   
              
      }
    }
    // this.modalRef = this.modalService.show(ModalComponent,modalOptions)

        this.dialogRefModal = this.dialog.open(ModalComponent, {
          width: '500px',
          data: modalOptions
        });
  }

  getContactElementDetails() {
    
    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: '',
      containerClass: '',
      animated: true,
     
    }
    // this.modalRef = this.modalService.show(ContactModalComponent,modalOptions)
        this.dialogRefContactModal = this.dialog.open(ContactModalComponent, {
          width: '500px',
          data: modalOptions
        });
  }
  

  Mail(){    
    this.mailText="mailto:asd.support@accenture.com";

    window.location.href = encodeURI(this.mailText);
  }


}
